module.exports = __webpack_public_path__ + "static/media/female.64f61eb3.svg";